// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2ghNu","right":"styles_right__2Scks"};